import styled from "styled-components";

const Section = styled.div``;

export { Section };
